<nav *ngIf="fatura && !fatura.isAutoNegotiationRedirectionEnabled && showTicket; else isShowTicket">

  <eae-bottom-sheet 
      [show]="showPorquePagarComPix" 
      title="Como pagar com pix?" 
      [subtitle]="'Efetue o pagamento em até 30 minutos'"
      (onClose)="setShowPorquePagarComPix(false)"
    >
      <div content>
        <ul class="agendaedu-list agendaedu-list-text">
          <li>
            1. Acesse seu aplicativo de Internet Banking ou App de Pagamentos
          </li>
          <li>
            2. Escolha pagar via Pix
          </li>
          <li>
            3. Copie e cole o código do pagamento
          </li>
        </ul>

        <ae-buttons>
          <ae-buttons-button class="ae-buttons ae-buttons-rounded">
            <button (click)="setShowPorquePagarComPix(false)">Entendi</button>
          </ae-buttons-button>
        </ae-buttons>
      </div>
    </eae-bottom-sheet>

  <ae-buttons>
    <ae-buttons-button>
      <a href="#" id="copyButton" (click)="copyCode($event)">Copiar Código</a>
    </ae-buttons-button>
  </ae-buttons>
</nav>

<div style="margin-bottom: 80px;" class="textInfoPix" (click)="setShowPorquePagarComPix(true)">Como pagar com pix?</div>

<ae-toast 
  message="Código Pix copiado" 
  *ngIf="copied"
  [timeElapsed]="3000"
  (onClose)="copied = false"
></ae-toast>

<ng-template #isShowTicket>
  <nav>
    <ae-buttons>
      <ae-buttons-button>
        <a href="#" (click)="clickShowTicket($event)">Código pix</a>
      </ae-buttons-button>
    </ae-buttons>
  </nav>
</ng-template>

<nav *ngIf="fatura && fatura.isAutoNegotiationRedirectionEnabled">
  <ae-buttons>
    <ae-buttons-button>
      <a href="/conheca-portal?faturaId={{fatura.bankSliptId}}">Simular negociação</a>
    </ae-buttons-button>
  </ae-buttons>
</nav>